// src/components/hub/work/SavePresetModal.js
import React, { useState } from "react";
import { popupBg, popupBorder, popupText, popupBtn, popupInput } from "../constants";

const SavePresetModal = ({ open, onClose, onSave }) => {
  const [name, setName] = useState("");

  if (!open) return null;

  const handleClose = () => {
    setName("");
    onClose();
  };

  const handleSave = async () => {
    if (!name.trim()) return;
    await onSave(name.trim());
    setName("");
    onClose();
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50" onClick={handleClose}>
      <div
        className={`${popupBg} ${popupBorder} ${popupText} rounded-lg p-6 w-96 shadow-xl`}
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className={`text-sm font-medium ${popupText} mb-4`}>
          Save current filters as preset
        </h3>
        <input
          autoFocus
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && name.trim()) handleSave();
            if (e.key === "Escape") handleClose();
          }}
          placeholder="Preset name"
          className={`w-full rounded-md ${popupInput} placeholder-gray-400 dark:placeholder-gray-500 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none mb-4`}
        />
        <div className="flex justify-end gap-2">
          <button onClick={handleClose} className={`px-3 py-1.5 text-sm ${popupBtn}`}>
            Cancel
          </button>
          <button
            onClick={handleSave}
            disabled={!name.trim()}
            className="px-3 py-1.5 text-sm rounded-md bg-blue-600 text-white hover:bg-blue-500 disabled:opacity-40 disabled:cursor-not-allowed"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default SavePresetModal;
